import React, { Component } from "react";
import StudentAppBar from '../StudentAppBar';
import Drawer from 'material-ui/Drawer';
import { List, ListItem } from 'material-ui/List';
import { Link } from "react-router";
import AdmissionApi from "../../Services/AdmissionApi";
import StudentSideBar from "../StudentSideBar";
import "./style.css";
import WelcomeImg from '../../assets/images/welcome.svg'
import ImgLoading from '../../assets/images/img-loading.gif'
import AdDemoImg from '../../assets/images/ad-demo.png'

import Dialog from 'material-ui/Dialog';
import moment from 'moment';

import Slider from "react-slick";


const SchoolDetailsModal = ({ isOpen, errors, onChange, onSubmit, school, lastClass, passingYear }) => {

  const actions = [
    <button
      className='btn btn--primary ml-2'
      style={{ marginRight: 30 }}
      onClick={onSubmit}
    >
      Submit
    </button>
  ];

  return (
    <Dialog
      className='dash-school-modal'
      title="School Details"
      modal={true}
      actions={actions}
      open={isOpen}
    >
      <div className='container'>
        <div className='row'>
          <div className='col-sm-12'>
            <div className={`form-group ${errors["school"] && 'm-0'}`}>
              <label>School</label>
              <input
                type="text"
                id="school"
                className="form-control alert-filter__input"
                placeholder="Enter your school name"
                value={school}
                onChange={onChange}
              />
            </div>
            <span style={{ color: "red", fontFamily: "italian" }}>
              {errors["school"]}
            </span>
          </div>
          <div className='col-sm-12 col-lg-6'>
            <div className={`form-group ${errors["lastClass"] && 'm-0'}`}>
              <label>Class</label>
              <input
                type="text"
                id="lastClass"
                className="form-control alert-filter__input"
                placeholder="eg. Class X"
                value={lastClass}
                onChange={onChange}
              />
            </div>
            <span style={{ color: "red", fontFamily: "italian" }}>
              {errors["lastClass"]}
            </span>
          </div>
          <div className='col-sm-12 col-lg-6'>
            <div className={`form-group ${errors["passingYear"] && 'm-0'}`}>
              <label>Year of passing class 12<sup>th</sup></label>
              <select
                className="form-control alert-filter__input modal-select"
                id="passingYear"
                value={passingYear}
                onChange={onChange}
              >
                <option value=''>Choose...</option>
                {Array.from(Array(10)).map((x, i) => (
                  <option key={i} value={new Date().getFullYear() + i}>{new Date().getFullYear() + i}</option>
                ))}
              </select>
            </div>
            <span style={{ color: "red", fontFamily: "italian" }}>
              {errors["passingYear"]}
            </span>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

const CourseCategoriesModal = ({ isOpen, options, selectedCategories, error, onChange, onSubmit, onCancel }) => {
  const _selected = selectedCategories.map(item => item.value)

  return (
    isOpen && (
      <div className="modal-container profile-model custombox-content custombox-x-center custombox-y-center custombox-top custombox-blur custombox-open">
        <div className="profile-model-info text-left g-max-width-950 g-bg-white g-overflow-y-auto g-pa-20">
          <div className="admn-modal-header">
            <h1 className="admn-modal-heading">Select <span className="gradient-text--primary">Any 3</span> categories</h1>
            <p className="m-0">
              Displayed below are 10 categories in which we will be creating
              and posting alerts on <span style={{ color: '#1B75BA' }}>notifyi.in</span>.
              You can choose up to 3 categories in which you can see alerts.
            </p>
          </div>
          <div className="g-color-text-light-v1 text-right" style={{ padding: !error && '11px 0' }}>
            <span style={{ color: "red", fontWeight: "100" }}>{error}</span>
          </div>
          <div>
            <form className="g-mb-30 categoyHeight">
              <div className="form-group">
                {options.map(item => (
                  <label
                    className="category-checkbox"
                    style={{ border: _selected.includes(item.id) && '3px solid var(--primary-400-base)' }}
                    key={item.id}
                  >
                    <input
                      type="checkbox"
                      style={{ marginTop: '5px', marginRight: '10px' }}
                      onChange={() => onChange(item)}
                      checked={_selected.includes(item.id)}
                    />
                    <div>
                      <h3 className="category-checkbox__heading">{item.name}</h3>
                      <p className="category-checkbox__para">{item.description}</p>
                    </div>
                  </label>
                ))}
              </div>
            </form>
          </div>
          <div className="admn-modal-footer">
            <button
              onClick={onCancel}
              className="btn btn--default"
              style={{ padding: '8px 16px' }}
            >
              Back
            </button>
            <button
              onClick={onSubmit}
              className="btn btn--primary ml-2"
              style={{ padding: '8px 16px' }}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    )
  )
}

class Dashboard extends Component {
  admissionsService = new AdmissionApi()

  state = {
    vWidth: null,
    isOpen: window.innerWidth < 980 ? false : true,
    id: null,
    userInfo: {},
    category: [],
    subjects: null,
    allChecked: false,
    checkedCount: 0,
    options: [],
    checkArray: [],
    showModal: false,
    check: false,
    subjectsObj: [],
    categoriesObj: [],
    admissionalerts: [],
    scholarships: [],
    logo: "",
    profileBar: false,
    careers: [],
    images: [],
    imagesId: [],
    selectedCategories: [],
    showSchoolDetailsModal: false,
    school: '',
    lastClass: '',
    passingYear: '',
    ads: [],
    errors: {
      selectedCategories: '',
      school: '',
      lastClass: '',
      passingYear: '',
    },
  }

  toggleProfileBar = () => {
    this.setState((prevState) => ({ profileBar: !prevState.profileBar }))
  }

  updateState = (newResponse) => {
    if (newResponse.data.success) {
      history.pushState(null, "", location.href.split("?")[0]);
      this.loadUserInfo();
      this.closeMode();
    }
  };

  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  closeMode() {
    this.setState({ showSchoolDetailsModal: false, showModal: false });
  }

  handleAlertsCallback = (newResponse) => {
    let data = newResponse.data._embedded;
    this.setState({
      admissionalerts: data.admissionalerts.data,
      scholarships: data.scholarships.data,
    })
  }

  loadOtherInfo = () => {
    const _userCategories = this.state.categoriesObj
    const userCategories = _userCategories.reduce((res, item) => [...res, item.value], [])

    let filters = ''
    const { passingYear } = this.state

    if (passingYear) filters += `&year_of_passing=${passingYear}`

    this.admissionsService.GetData(
      this.handleAlertsCallback,
      `v1/alerts/dashboard?column=created_at&order=desc&course_category_id=${userCategories}${filters}`
    )

    let formData = new FormData()
    formData.append('sortParam', 'createdAt')
    formData.append('sortBy', 'desc')
    formData.append('perPage', 9999999999999)
    formData.append('filterByLiveAdv', '1')
    _userCategories.forEach(item => formData.append('categoryIds[]', item.value))

    this.admissionsService.getAds(
      (res) => {
        this.setState({ ads: res.data._embedded.Advertisements })
      },
      `v1/advertisement/list`,
      formData
    )

  }

  cbCourseCategories = (newResponse) => {
    if (newResponse.data.success) {
      var indents = [];
      var checkArr = [];
      for (var i = 0; i < newResponse.data._embedded.category.length; i++) {
        let obj = {
          name: newResponse.data._embedded.category[i].name,
          id: newResponse.data._embedded.category[i].id,
          description: newResponse.data._embedded.category[i].description,
        };
        checkArr.push(false);
        indents.push(obj);
      }

      this.setState({ options: indents, checkArray: checkArr });
    }
  }

  studentResponse = (newResponse) => {
    if (!newResponse.data.success) return
    const student = newResponse.data._embedded.students[0]

    if (!student.categories) {

      this.admissionsService.GetData(
        this.cbCourseCategories,
        "v1/students/alert/category"
      )

      this.setState({
        showSchoolDetailsModal: true,
        id: student.id,
      });

    } else {
      this.setState({
        showSchoolDetailsModal: false,
        userInfo: student,
        subjectsObj: student.subjects,
        categoriesObj: student.categories,
        passingYear: student.batch
      }, this.loadOtherInfo);
      localStorage.setItem(
        "categories",
        JSON.stringify(student.categories)
      );
    }
  }

  loadUserInfo() {
    let obj = localStorage.getItem("userId");
    this.admissionsService.GetData(
      this.studentResponse,
      "v1/students?user_id=" + obj
    );
  }

  componentDidMount() {
    var isLogin = localStorage.getItem("isLogin")
    if (isLogin == 1) {
      localStorage.setItem("isLogin", "1")
      this.loadUserInfo()

      let _type = 1;
      localStorage.setItem("inprofile", true);
      localStorage.setItem("type", _type);

      this.getCareerData()
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);

    } else {
      this.context.router.push("/signIn");
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ vWidth: window.innerWidth });
  }

  updateImageState = (newResponse) => {
    if (
      newResponse.data.images != undefined &&
      newResponse.data.images != null &&
      newResponse.data.images.length > 0
    ) {
      let images = [];
      let newCareers = [];

      let careers = this.state.careers;
      images = newResponse.data.images;
      if (newResponse.data.success) {
        careers.map((item, _index) => {
          images.map((obj, index) => {
            if (item.imageid != null || item.imageid != undefined) {
              if (item.imageid == obj.id) {
                item.imageurl = "https://media.notifyi.in/" + obj.url;
                newCareers.push(item);
              } else {
                // if (images.length == index + 1) {
                //   newCareers.push(item);
                // }
              }
            } else {
              if (newCareers.length > 0) {
                newCareers.forEach((newCar, i) => {
                  if (newCar.id == item.id) {
                  } else {
                    if (newCareers.length == i + 1) {
                      newCareers.push(item);
                    }
                  }
                });
              } else {
                newCareers.push(item);
              }
            }
          });
        });

        this.setState({ careers: newCareers, images: images });
      }
    }
  };

  updateCareerState = (newResponse) => {
    let ids = [];
    let careers = [];
    careers = newResponse.data._embedded.careers;
    careers.map((item) => {
      ids.push(item.imageid);
    });

    let data = { images: ids };
    this.admissionsService.createMediaNew(
      this.updateImageState,
      data,
      "v1/media/images/get-all"
    );
    this.setState({
      careers: careers,
      imagesId: ids,
      showLoading: false,
      total: newResponse.data._embedded.total,
    });
  };

  getCareerData() {
    this.admissionsService.GetData(
      this.updateCareerState,
      "v1/career?page=1&pageSize=999999&column=created_at&order=desc"
    );
  }

  handleCategoryValidation = () => {
    let fields = this.state;
    let formIsValid = true;
    let errors = {
      selectedCategories: '',
    }

    // Course Categories
    if (!fields["selectedCategories"].length) {
      formIsValid = false;
      errors["selectedCategories"] =
        "You have to select at least 1 category";
    }

    this.setState({ errors });
    return formIsValid;
  }

  handleSchoolDetailsValidation = () => {
    let fields = this.state;
    let formIsValid = true;
    let errors = {
      school: '',
      lastClass: '',
      passingYear: '',
    }

    //School name
    if (!fields["school"]) {
      formIsValid = false;
      errors["school"] = "Cannot be empty";
    }

    if (fields["school"] && /[^A-Za-z \.]/.test(fields['school'])) {
      formIsValid = false;
      errors["school"] = "Special characters and numbers are not allowed";
    }

    //Last Class
    if (!fields["lastClass"]) {
      formIsValid = false;
      errors["lastClass"] = "Cannot be empty";
    }

    //Passing Year
    if (!fields["passingYear"]) {
      formIsValid = false;
      errors["passingYear"] = "Cannot be empty";
    }

    this.setState({ errors });
    return formIsValid;
  }

  handleSubmitCategories = () => {
    if (!this.handleCategoryValidation()) return
    const {
      school,
      lastClass,
      passingYear,
      selectedCategories
    } = this.state


    let categoryObj = localStorage.getItem("userInfo");
    let Obj = JSON.parse(categoryObj);

    Obj.id = this.state.id;
    Obj.categories = selectedCategories;
    Obj.school_name = school.trim()
    Obj.class = lastClass
    Obj.batch = passingYear
    Obj.date_of_birth = moment(Obj.date_of_birth).format('YYYY-MM-DD')

    this.closeMode();
    this.admissionsService.updateCredentials(
      this.updateState,
      Obj,
      "v1/students"
    )
  }

  handleSubmitSchoolDetails = () => {
    if (!this.handleSchoolDetailsValidation()) return
    this.setState({ showModal: true })
  }

  resetErrorMsg = (errorId) => {
    this.setState((preState) => ({
      errors: { ...preState.errors, [errorId]: "" },
    }))
  }

  handleFormFieldChange = (e) => {
    e.preventDefault()
    const { id, value } = e.target
    this.setState({
      [id]: value
    })

    this.resetErrorMsg(id)
  }

  closeCategoriesModal = () => this.setState({ showModal: false })

  handleCategoryChange = (obj) => {
    const { selectedCategories } = this.state
    const isAvailable = selectedCategories.find(item => item.value === obj.id)

    if (isAvailable) {
      const updatedCategories = selectedCategories.filter(item => item.value !== obj.id)
      this.setState(state => ({
        selectedCategories: updatedCategories,
        errors: {
          ...state.errors,
          selectedCategories: ''
        }
      }))
    } else if (selectedCategories.length < 3) {
      this.setState(state => ({
        selectedCategories: [
          ...state.selectedCategories,
          {
            label: obj.name,
            value: obj.id
          }
        ],
        errors: {
          ...state.errors,
          selectedCategories: ''
        }
      }))
    } else {
      this.setState(state => ({
        errors: {
          ...state.errors,
          selectedCategories: 'You can only select 3 categories max.'
        }
      }))
    }
  }

  toggleSidebar = () => {
    this.setState(state => ({ isOpen: !state.isOpen }))
  }

  handleRequestChange = (isOpen) => {
    this.setState({ isOpen })
  }

  handleAdClick = (item) => {
    const formData = new FormData()
    const user = JSON.parse(localStorage.getItem('userInfo'))

    formData.append('advertisementId', item.id)
    formData.append('name', `${user.first_name} ${user.last_name}`)
    formData.append('email', user.email)
    formData.append('mobile', '9833245120')
    formData.append('status', 1)


    this.admissionsService.createNew(
      (res) => {
        window.open(item.url)
      },
      formData,
      "v1/advertisement/student-click"
    )
  }

  render() {
    const {
      categoriesObj,
      admissionalerts,
      scholarships,
      careers,
      showModal,
      showSchoolDetailsModal,
      options,
      errors,
      selectedCategories,
      school,
      lastClass,
      passingYear,
      isOpen,
      vWidth,
      ads
    } = this.state

    const scrollSettings = {
      dots: false,
      infinite: true,
      slidesToShow: vWidth >= 576 ? 3 : 2,
      slidesToScroll: 1,
      autoplay: true,
      speed: 5000,
      autoplaySpeed: 0,
      cssEase: "linear"
    }

    const adSliderSettings = {
      dots: false,
      fade: true,
      infinite: true,
      autoplay: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    }

    return (
      <div className="dash-container">
        <StudentSideBar isOpen={isOpen} handleRequestChange={this.handleRequestChange} />

        <div className="dash-content">
          <StudentAppBar title="Dashboard" toggleSidebar={this.toggleSidebar} router={this.props.router} />
          <div className="container">
            <section className="dash-welcome">
              <div>
                <h2 className="dash-welcome__heading d-inline-block">Hello {this.state.userInfo.first_name}!</h2>
                <Link to="/profile"><i className="icon-pencil dash-welcome__icon" /></Link>
                <p>Here you'll get all the alerts for your selected course categories:</p>
                {categoriesObj.map(item => (
                  <span key={item.value} className="badge badge--primary mr-2 mb-1">{item.label}</span>
                ))}
              </div>
              <figure>
                <img src={WelcomeImg} alt="welcome avatar" />
              </figure>
            </section>
            <section className="dash-list">
              <div className="dash-list__heading">
                <h2>Latest Admn. Alerts</h2>
                <Link to="/AdmissionAlerts" className="btn btn-link dash-list__btn">View All &rarr;</Link>
              </div>
              <div className="dash-list__body">
                <List>
                  {admissionalerts.map(item => (
                    <ListItem
                      key={item.id}
                      className="test"
                      hoverColor="transparent"
                      innerDivStyle={{ padding: '10px 0' }}
                      rightIconButton={<Link to={{ pathname: "/alertDetail", state: { data: item } }}>details</Link>}
                      primaryText={<div className="dash-list__item-heading">{item.institution_name}</div>}
                      secondaryText={`Last date to apply: ${item.last_date_online}`}
                    />
                  ))}
                  {!admissionalerts.length && (
                    <ListItem
                      className="test"
                      hoverColor="transparent"
                      innerDivStyle={{ padding: '10px 0' }}
                      primaryText={<div className="dash-list__item-heading">No Alerts Available!</div>}
                    />
                  )}
                </List>
              </div>
            </section>
            <section className="dash-cards">
              <div className="dash-list__heading">
                <h2>Career</h2>
                <Link to="/careers" className="btn btn-link dash-list__btn" style={{ paddingRight: 28 }}>View All &rarr;</Link>
              </div>
              <div className="dash-cards__x">
                <Slider {...scrollSettings}>
                  {careers.map((item, i) => (
                    <Link key={item.id} className="dash-card" to={{ pathname: "/careerDetail", state: { data: item } }}>
                      <img width={209} height={200} src={item.imageurl ? item.imageurl : ImgLoading} alt={item.title} />
                      <h4>{item.title}</h4>
                      {/* <span className={`badge badge--success ${i > 4 && 'd-none'}`}>New</span> */}
                    </Link>
                  ))}
                </Slider>
              </div>
            </section>
            <section>
              <div className="dash-adv dash-adv-mb">
                <h4 className='font-bold'>Advertisement</h4>
                {ads.length ? (
                  <Slider className="adv-slider" {...adSliderSettings}>
                    {ads.map(item => (
                      <img key={item.id} src={item.fileUrl} alt={item.university.name} onClick={() => this.handleAdClick(item)} />
                    ))}
                  </Slider>
                ) : (
                  <img src={AdDemoImg} alt="Join Admission Campus" />
                )}
              </div>
            </section>
            <section className="dash-list">
              <div className="dash-list__heading">
                <h2>Latest Scholarships Alerts</h2>
                <Link to="/scholarship" className="btn btn-link dash-list__btn">View All &rarr;</Link>
              </div>
              <div className="dash-list__body">
                <List>
                  {scholarships.map(item => (
                    <ListItem
                      key={item.id}
                      hoverColor="transparent"
                      innerDivStyle={{ padding: '10px 0' }}
                      rightIconButton={<Link to={{ pathname: "/scholarshipDetail", state: { data: item } }}>details</Link>}
                      primaryText={<div className="dash-list__item-heading">{item.name}</div>}
                      secondaryText={`Last date to apply: ${moment(item.scholarship_last_date).format('DD/MM/YYYY')}`}
                    />
                  ))}
                  {!scholarships.length && (
                    <ListItem
                      className="test"
                      hoverColor="transparent"
                      innerDivStyle={{ padding: '10px 0' }}
                      primaryText={<div className="dash-list__item-heading">No Alerts Available!</div>}
                    />
                  )}
                </List>
              </div>
            </section>
          </div>
        </div>

        <Drawer className="dash-profile-bar" open={true} openSecondary>
          <section>
            <div className="dash-adv">
              <h2>Advertisement</h2>
              {ads.length ? (
                <Slider className="adv-slider" {...adSliderSettings}>
                  {ads.map(item => (
                    <img key={item.id} src={item.fileUrl} alt={item.university.name} onClick={() => this.handleAdClick(item)} />
                  ))}
                </Slider>
              ) : (
                <img src={AdDemoImg} alt="Join Admission Campus" />
              )}
            </div>
          </section>
        </Drawer>
        <CourseCategoriesModal
          isOpen={showModal}
          onCancel={this.closeCategoriesModal}
          options={options}
          selectedCategories={selectedCategories}
          error={errors.selectedCategories}
          onChange={this.handleCategoryChange}
          onSubmit={this.handleSubmitCategories}
        />
        <SchoolDetailsModal
          isOpen={showSchoolDetailsModal}
          onChange={this.handleFormFieldChange}
          school={school}
          lastClass={lastClass}
          passingYear={passingYear}
          errors={errors}
          onSubmit={this.handleSubmitSchoolDetails}
        />
      </div>
    )
  }
}

export default Dashboard;


/** WEBPACK FOOTER **
 ** ./src/components/Dashboard/index.js
 **/